import {
  Bell,
  Mail,
  Key,
  KeyRound,
  Megaphone,
  RefreshCw,
  Webhook,
  Ticket,
  EyeOff,
  SlidersHorizontal,
  Send,
  type LucideIcon,
} from 'lucide-react';
import type { TriggerActionType, TriggerAction } from '../types';

export interface TriggerActionConfig {
  label: string;
  description: string;
  icon: LucideIcon;
  defaultData: Partial<TriggerAction>;
}

export const TRIGGER_ACTIONS: Record<TriggerActionType, TriggerActionConfig> = {
  send_notification: {
    label: 'Отправить уведомление',
    description: 'Push, Telegram или in-app уведомление',
    icon: Bell,
    defaultData: { type: 'send_notification', channel: 'TELEGRAM' },
  },
  send_email: {
    label: 'Отправить email',
    description: 'Электронное письмо пользователю',
    icon: Mail,
    defaultData: { type: 'send_email' },
  },
  grant_access: {
    label: 'Выдать доступ',
    description: 'Дать доступ к курсу, каналу или контенту',
    icon: Key,
    defaultData: { type: 'grant_access', targetType: 'COURSE' },
  },
  revoke_access: {
    label: 'Отозвать доступ',
    description: 'Забрать доступ к курсу, каналу или контенту',
    icon: KeyRound,
    defaultData: { type: 'revoke_access', targetType: 'COURSE' },
  },
  send_broadcast: {
    label: 'Запустить рассылку',
    description: 'Запустить существующую рассылку',
    icon: Megaphone,
    defaultData: { type: 'send_broadcast' },
  },
  update_status: {
    label: 'Обновить статус',
    description: 'Изменить статус заказа или подписки',
    icon: RefreshCw,
    defaultData: { type: 'update_status' },
  },
  webhook: {
    label: 'Вызвать webhook',
    description: 'Отправить HTTP-запрос на внешний URL',
    icon: Webhook,
    defaultData: { type: 'webhook', method: 'POST', headers: {} },
  },
  deactivate_channel_pass: {
    label: 'Деактивировать пропуск',
    description: 'Отключить пропуск канала (isActive = false)',
    icon: Ticket,
    defaultData: { type: 'deactivate_channel_pass' },
  },
  hide_channel_pass: {
    label: 'Скрыть пропуск из магазина',
    description: 'Скрыть пропуск канала из списка покупки',
    icon: EyeOff,
    defaultData: { type: 'hide_channel_pass' },
  },
  change_family_slots: {
    label: 'Изменить слоты семьи',
    description: 'Увеличить или уменьшить количество слотов семейной подписки',
    icon: SlidersHorizontal,
    defaultData: { type: 'change_family_slots', delta: 0 },
  },
  send_channel_invite: {
    label: 'Отправить приглашение в канал',
    description: 'Отправить пользователю ссылку-приглашение в Telegram канал',
    icon: Send,
    defaultData: { type: 'send_channel_invite' },
  },
};

export function createDefaultAction(type: TriggerActionType): TriggerAction {
  const config = TRIGGER_ACTIONS[type];
  return { type, ...config.defaultData } as TriggerAction;
}

export function getActionLabel(type: TriggerActionType): string {
  return TRIGGER_ACTIONS[type]?.label ?? type;
}

export function getActionIcon(type: TriggerActionType): LucideIcon {
  return TRIGGER_ACTIONS[type]?.icon ?? Bell;
}
